<template>
    <div v-shortkey="{winSave: ['ctrl', 's'], macSave: ['meta', 's'], winUnread: ['ctrl', 'esc'], macUnread: ['meta', 'esc']}" @shortkey="keyDown" class="form-info" :class="{'whirl ringed': !form && !loaded}">
        <div class="form-details" v-if="form">
            <div class="btn-toolbar border-hr border-bottom mb-3 pb-3 d-flex justify-content-between">
                <div class="text-left">
                    <button @click="back()" class="btn btn-light mt-1">
                        <i class="fas fa-arrow-left"></i>
                         Terug naar overzicht
                    </button>
                </div>
                <div class="d-flex justify-content-end align-items-center">
                    <b-dropdown v-if="!isFinished && !createMode" variant="link" class="toolbar-dd pl-0 pr-0 mr-2" no-caret>
                        <template slot="button-content">
                            <button class="btn btn-light">Formulier afhandelen <i class="fas fa-chevron-down"></i></button>
                        </template>
                        <b-dropdown-item @click="statusUpdate(2)"><i class="fas fa-folder"></i> Archiveren</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="statusUpdate(5)"><i class="fas fa-times-circle"></i> Niet relevant</b-dropdown-item>
                        <b-dropdown-item @click="statusUpdate(6)"><i class="fas fa-camera"></i> Fotoshoot</b-dropdown-item>
						<b-dropdown-item @click="forwardLead()"><i class="fas fa-paper-plane"></i> Doorsturen naar...</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item variant="danger" @click="remove('spam')"><i class="fas fa-ban"></i> Als spam markeren</b-dropdown-item>
                    </b-dropdown>

                    <button @click="statusUpdate(settings.openStatusId)" class="btn btn-light mr-2" v-if="form.status_id === 2 || form.status_id === 12">
                        <em class="fa fa-folder-open"></em> Heropenen
                    </button>

                    <button @click="statusUpdate(settings.awaitingCustomerStatusId)" class="btn btn-light mr-2" v-if="form.status_id === 1">
                        <em class="fa fa-hourglass-half"></em> In afwachting
                    </button>

                    <button @click="statusUpdate(settings.offerStatusId)" class="btn btn-light mr-2" v-if="form.status_id !== parseInt(settings.offerStatusId, 10) && !isFinished && !createMode">
                        <em class="fas fa-sliders-h"></em> Offertetraject
                    </button>

                    <button class="btn btn-light mr-2" v-if="!isFinished && form.read" @click="unread">
                        <em class="fa fa-eye-slash"></em> Markeer als ongelezen
                    </button>

                    <detail-help link-type="button" uid="2"/>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-4">
                    <b-card header-bg-variant="light"
                            border-variant="light-dark"
                            header-text-variant="dark"
                            class="mb-3">
                        <template slot="header">
                            <div class="d-flex justify-content-between">
                                <h4 v-if="createMode" class="mb-0">NV-lead aanmaken</h4>
                                <h4 v-else class="mb-0">NV-lead {{form.id}} / {{form.refcode}}</h4>
                                <div class="ml-2 d-flex justify-content-end" v-if="form.status">
                                    <div class="badge mr-2 badge-info" v-bind:style="{backgroundColor: form.status.color}">
										<i v-if="form.finished_at !== null" class="fas fa-check mr-2"></i>{{form.status.title}}
									</div>
									<timer
										v-if="form"
										:due="form.response_due.dueDate"
										:elapsed="form.response_due.elapsed"
										:remaining="form.response_due.remaining"
										:is-open="form.response_due.isOpen"
										:switch-on="form.response_due.until"
										:completed="form.response_due.respondedAt"
										:horizontal="true"
									></timer>
                                </div>
                            </div>
                        </template>

                        <formdata :form="form" :ask-message="createMode" :onlyImportant="true" :editable="true" @updated="updated"></formdata>
                    </b-card>

                    <contact-moments v-if="!createMode" :class="{'whirl ringed': !loaded}" :updateable="!isFinished" :lead="form" @updated="updated"></contact-moments>
                </div>

                <div class="col-md-8">
                    <nv-lead-form ref="nvleadform" :key="'nv-lead-form-' + $route.params.leadId" :class="{'whirl ringed': !loaded}" v-if="!isFinished" @updated="updated" :form="loadedForm" @refCode="setRefCode" @refresh="loadForm()"></nv-lead-form>
                    <finished-details v-if="isFinished" :lead="form"></finished-details>
                </div>
            </div>
        </div>

		<div class="modal fade bd-example-modal-lg" id="forwardModal" tabindex="-1" role="dialog" aria-labelledby="forwardModalLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="forwardModalLabel">Doorsturen naar...</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body">
						<div class="col-lg-6 mt-2 mb-2 float-left">
							<button type="button" @click="statusUpdate(7)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-bullhorn"></i> Afdeling marketing</button>
						</div>
						<div class="col-lg-6 mt-2 mb-2 float-left">
							<button type="button" @click="statusUpdate(8)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-users"></i> Afdeling HR</button>
						</div>
						<div class="col-lg-6 mt-2 mb-2 float-left">
							<button type="button" @click="statusUpdate(9)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-calculator"></i> Afdeling administratie</button>
						</div>
						<div class="col-lg-6 mt-2 mb-2 float-left">
							<button type="button" @click="statusUpdate(10)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-life-ring"></i> Afdeling facilitair</button>
						</div>
						<div class="col-lg-6 mt-2 mb-1 float-left">
							<button type="button" @click="statusUpdate(14)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-hotel"></i> De Werelt - Lunteren</button>
						</div>
						<div class="col-lg-6 mt-2 mb-1 float-left">
							<button type="button" @click="statusUpdate(15)" class="btn btn-ep btn-block mb-1" data-dismiss="modal"><i class="button-fa-left fas fa-hotel"></i> De Werelt - Garderen</button>
						</div>
					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-dismiss="modal">Annuleren</button>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import formKeys from './../../helpers/formKeys';
    import nvLeadForm from "./nvLeadForm";
    import FinishedDetails from "./finishedDetails";
    import ContactMoments from "./contactMoments";
    import detailHelp from "./detailHelp";
	import Timer from "./timer.vue";

    export default {
        components: {
			Timer,
            detailHelp,
            ContactMoments,
            FinishedDetails,
            nvLeadForm
        },
        props: {
            forms: {
                type: Array,
                required: true,
            },
            manualSource: {
                type: Number
            }
        },
        data() {
            return {
                errors: [],
                input: {
                    accepted: false
                },
                importantFieldsData: null,
                validationErrors: [],
                statusses: [
                    {
                        key: "Aanvraag",
                        value: "Aanvraag"
                    },{
                        key: "Optie",
                        value: "Optie"
                    },{
                        key: "Definitief",
                        value: "Definitief"
                    },{
                        key: "Geannuleerd",
                        value: "Geannuleerd"
                    },
                ],
                today: this.moment(),
                dateSelected: null,
                loadedForm: null,
                loaded: null,
                settings: {},
                refCode: null,
                hasOffer: false
            }
        },
        watch: {
            '$route.params.leadId'() {
                this.loadForm();
                this.onOpen();
            },
            loadedForm(val) {
                if(val && val.id) {
                    this.$emit('updated', val);
                }
            },
            form(val) {
                this.readNow();
            },
            dateSelected(date) {
                this.form.event.date = date;
            },
            'form.event.date'(date) {
                this.dateSelected = date
            }
        },
        beforeMount() {
            window.addEventListener('keyup', this.keyUp);
        },
        beforeDestroy () {
            window.removeEventListener('keyup', this.keyUp)
        },
        mounted() {
            this.loadForm();
            this.onOpen();

            if(this.createMode) {
                this.loadedForm = {
                    form: 'Nieuwe NV lead',
                    url: null,
                    site: 'Handmatig aangemaakt',
                    values: {},
                    event: {
                        number: null,
                        bron: this.manualSource,
                    },
                    params: {},
                    tracking: {},
                    is_nv_lead: true,
                };
                this.loaded = new Date();
            }
        },
        updated() {
            this.settings = this.$store.getters['settingsStore/settings'];
        },
        computed: {
            isFinished() {
                return this.form
                        && this.form.status
                        && this.form.status.finished;
            },
            createMode() {
                return this.$route.params.leadId === undefined || this.$route.params.leadId === 'create'
            },
            form() {
                if(!this.forms) {
                    return null;
                }

                if(this.loadedForm) {
                    return this.loadedForm;
                }

                for(let index in this.forms) {
                    if(!this.forms.hasOwnProperty(index)) {
                        continue;
                    }
                    let form = this.forms[index];
                    if(form.id === parseInt(this.$route.params.leadId)) {
                        return form;
                    }
                }
                return null;
            },
            changed() {

            },
            importantFields() {
                this.importantFieldsData = formKeys.findRelevantData(this.form.values);
                return this.importantFieldsData;
            }
        },
        methods: {
            loadForm() {
                if(this.createMode) {
                    return;
                }
                this.loaded = null;
                this.errors = [];
                axios.get('/api/v1/leads/form/' + this.$route.params.leadId + '/')
                    .then(response => {
                        this.loaded = new Date();
                        this.loadedForm = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            mappedKey(key) {
                return formKeys.mapKey(key, key);
            },
            keyUp(event) {
                switch(event.which) {
                    case 39:
                        event.stopPropagation();
                    break;

                    case 37:
                        event.stopPropagation();
                    break;

                    case 27:
                        if(this.$root.modelOpen) {
                            this.$root.$emit('bv::hide::modal', this.$root.modelOpen);
                        }else{
                            this.back();
                        }
                    break;
                }
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'winSave':
                    case 'macSave':
                        this.$refs.leadform.update();
                    break;

                    case 'winUnread':
                    case 'macUnread':
                        this.unread();
                    break;
                }
            },
            onOpen() {
                if(this.form === null) {
                    return;
                }
                window.scrollTo(0,0);
                this.readNow();
                if(window.hotjarEnabled) {
                    hj('tagRecording', ['lead-' + this.$route.params.leadId]);
                }
            },
            readNow() {
                if(this.createMode) {
                    return;
                }

                if(!this.form.read) {
                    axios.put('/api/v1/leads/form/' + this.form.id + '/read');
                    this.form.read = true;
                }
            },
            unread() {
                this.$emit('closeDetails');
                axios.delete('/api/v1/leads/form/' + this.form.id + '/read');
                this.form.read = false;
                this.back();
            },
            back() {
                this.$router.replace({name: 'home'})
            },
            hideContactPersonSelect () {
                this.$refs['form-view-contact-' + this.form.id].hide();
            },
            remove(reason = 'manual') {
                let mes = 'Dit formulier verwijderen?';
                let but = 'Verwijderen';
                if(reason === 'spam') {
                    mes = 'Dit formulier markeren als spam en verwijderen?';
                    but = 'Markeren als spam en verwijderen';
                }
                this.$swal({
                    title: mes,
                    text: "Hiermee wordt deze lead pernament verwijderd.",
                    type: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-ep',
                    cancelButtonClass: 'btn btn-light mr-2',
                    confirmButtonText: but,
                    reverseButtons: true,
                    focusConfirm: false,
                    focusCancel: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        this.$swal.showLoading();
                        return axios.delete('/api/v1/leads/form/' + this.form.id+ '?reason=' + reason)
                            .then(response => {
                                return response.status;
                            })
                            .catch(error => {
                                this.$swal({
                                    type: 'error',
                                    showConfirmButton: false,
                                    html: this.$errorMessage(error)
                                });
                            })

                    }
                }).then((result) => {
                    if (result.value) {
                        this.$router.go(-1);
                        this.$emit('formDeleted', this.form.id);
                        this.$swal(
                            'Verwijderd!',
                            'De lead is verwijderd',
                            'success'
                        ).then((result) => {
                        })
                    }
                })
            },
            archive(status = 2) {
                let mes = 'Dit formulier archiveren?';
                let but = 'Archiveren';
                if(status === 1) {
                    mes = 'Dit formulier opnieuw openen?';
                    but = 'Openen';
                }
                this.$swal({
                    title: mes,
                    type: 'question',
                    showCancelButton: true,
                    buttonsStyling: false,
					confirmButtonClass: 'btn btn-ep',
					cancelButtonClass: 'btn btn-light mr-2',
                    confirmButtonText: but,
                    reverseButtons: true,
                    focusConfirm: true,
                    focusCancel: false,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        this.$swal.showLoading();
                        return axios.put('/api/v1/leads/form/' + this.form.id + '/update', {
                            'status_id': status
                        })
                            .then(response => {
                                return response;
                            })
                            .catch(error => {
                                this.$swal({
                                    type: 'error',
                                    showConfirmButton: false,
                                    html: this.$errorMessage(error)
                                });
                            })

                    }
                }).then((data) => {
                    let response = data.value;
                    if (response.data) {
                        this.$emit('finishedDetails', response.data);
                        this.updated(response.data);
                        this.$emit('closeDetails');
                    }
                })
            },
            getStatusMessage(status) {
                switch (status) {
                    case 1:
                        return {
                            message: 'Dit formulier opnieuw openen?',
                            button: 'Openen'
                        };
                    case 2:
                        return {
                            message: 'Dit formulier archiveren?',
                            button: 'Archiveren'
                        };
                    case 4:
                        return {
                            message: 'Dit formulier sluiten?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            button: 'Sluiten'
                        };
                    case 5:
                        return {
                            message: 'Dit formulier melden als niet relevant?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            button: 'Niet relevant'
                        };
                    case 6:
                        return {
                            message: 'Dit formulier markeren als fotoshoot?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            button: 'Aanvraag voor een fotoshoot'
                        };
                    case 7:
                        return {
                            message: 'Deze informatie doorsturen naar marketing?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            forwardComment: true,
                            button: 'Doorsturen'
                        };
                    case 8:
                        return {
                            message: 'Deze informatie doorsturen naar HR?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            forwardComment: true,
                            button: 'Doorsturen'
                        };
                    case 9:
                        return {
                            message: 'Deze informatie doorsturen naar administratie?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            forwardComment: true,
                            button: 'Doorsturen'
                        };
                    case 10:
                        return {
                            message: 'Deze informatie doorsturen naar facilitair?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            forwardComment: true,
                            button: 'Doorsturen'
                        };
                    case 11:
                        return {
                            message: 'Deze informatie doorsturen naar keuken?',
                            text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
                            forwardComment: true,
                            button: 'Doorsturen'
                        };
					case 14:
						return {
							message: 'Deze informatie doorsturen naar De Werelt in Lunteren?',
							text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
							forwardComment: true,
							button: 'Doorsturen'
						};
					case 15:
						return {
							message: 'Deze informatie doorsturen naar De Werelt in Garderen?',
							text: 'Het formulier wordt hiermee afgerond en kan niet opnieuw in behandeling worden genomen.',
							forwardComment: true,
							button: 'Doorsturen'
						};
                    default:
                        return {
                            message: 'Status bijwerken?',
                            button: 'Bijwerken'
                        };
                }
            },
            statusUpdate(status = 2) {
                let mes = this.getStatusMessage(status).message;
                let but = this.getStatusMessage(status).button;
                let text = this.getStatusMessage(status).text;
                let forwardComment = this.getStatusMessage(status).hasOwnProperty('forwardComment') ? this.getStatusMessage(status).forwardComment : false;

                let options = {
                    title: mes,
                    text: text,
                    type: 'question',
                    showCancelButton: true,
                    buttonsStyling: false,
					confirmButtonClass: 'btn btn-ep',
					cancelButtonClass: 'btn btn-light mr-2',
                    confirmButtonText: but,
                    reverseButtons: true,
                    focusConfirm: true,
                    focusCancel: false,
                    showLoaderOnConfirm: true,
                    preConfirm: (value) => {
                        this.$swal.showLoading();

                        let params = {
                            'status_id': status
                        };

                        if(forwardComment) {
                            params.forward_comment = value;
                        }

                        return axios.put('/api/v1/leads/form/' + this.form.id + '/update', params)
                            .then(response => {
                                return response;
                            })
                            .catch(error => {
                                this.$swal({
                                    type: 'error',
                                    showConfirmButton: false,
                                    html: this.$errorMessage(error)
                                });
                            })
                    }
                };

                if(forwardComment) {
                    options.input = 'textarea';
                    options.inputPlaceholder = 'Opmerkingen/bericht'
                }

                this.$swal(options).then((data) => {
                    let response = data.value;
                    if (response && response.data) {
                        this.updated(response.data);
                        this.$emit('closeDetails');
                    }
                })
            },
			forwardLead() {
				$('#forwardModal').modal({
					keyboard: false
				})
			},
            updated(data) {
                this.loadedForm = data;

                if(this.form && data && data.id) {
                    this.$emit('updated', data);
                }

            },
            setRefCode(refCode) {
                this.refCode = refCode;
            },
            saveToEp() {
                this.$swal.showLoading();

                this.$swal({
                    title: 'Bezig met opslaan',
                    html: 'We versturen nu de data...',
                    allowOutsideClick: true,
                    onOpen: () => {
                        this.$swal.showLoading()
                    }
                });

                let params = Object.assign({}, this.form);
                params.event = this.field;
            }
        }
    }
</script>

<style lang="scss">
    .form-info {
        min-height: 400px;
    }
    .form-details {
        .toolbar-dd .dropdown-toggle-no-caret {
            padding: 0;
        }

        .heading {
            .title {
                font-size: 1.2em;
            }
        }
        .sub-title {
            font-weight: bolder;
            text-transform: uppercase;
            text-space: 2;
        }
        .assignee {
            color: #212529;
            max-width: 290px;
            .card-body {
                padding: 0.8rem;
            }
        }
        .description-textarea {
            min-height: 90px;
            max-height: 240px;
        }
    }

	.button-fa-left {
		float: left;
		line-height: 23px;
	}
</style>